import { useForm, FormProvider } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { stringToJson } from 'lib/zod/stringToJson';
import { ENDPOINT_OPTIONS } from '../constants';

const schema = z.object({
  apiKey: z.string().min(1).trim(),
  endpoint: z.enum(ENDPOINT_OPTIONS),
  JSONsrc: stringToJson,
});

export type EventUploaderFormProviderType = Required<z.infer<typeof schema>>;

type EventUploaderFormProviderProps = {
  defaultValues?: EventUploaderFormProviderType;
  children: React.ReactNode;
};

export const EventUploaderFormProvider = ({
  children,
  defaultValues,
}: EventUploaderFormProviderProps) => {
  const methods = useForm<EventUploaderFormProviderType>({
    mode: 'onChange',
    resolver: zodResolver(schema),
    defaultValues,
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
